
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"toStroke",attrs:{"d":"M5 21.287a.087.087 0 01-.046-.011 7.601 7.601 0 0115.092 0 .087.087 0 01-.046.011H5z","stroke":"#042132","stroke-width":"1.8"}}),_c('circle',{staticClass:"toStroke",attrs:{"cx":"12.5","cy":"7.313","r":"4.412","stroke":"#042132","stroke-width":"1.8"}})])
          )
        }
      }
    